module.exports = __webpack_public_path__ + "img/area-5-video1-cover.39ebf5d.jpg";